import React, { useRef, useState } from "react";
import { ButtonStyleVerde, CssTextField, DivBackgroundDasboard, MaxDiv, PaperStyle, TypographyStyleSecundary } from "../../../styles/Styles";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderCustom from "../../../components/header/HeaderCustom";
import { Box, Alert, Snackbar, Checkbox, Typography, Link } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { AccountBalance, AccountCircle, AlternateEmail, Email, FolderShared } from "@mui/icons-material";
import SplashLoading from "../../../components/splashLoading/SplashLoading";
import { useSelector } from "react-redux";
import InputAdornment from '@mui/material/InputAdornment';
import dni from '../../../../src/assets/dni.png';
import { postAliasTransferir, postConsultaPagoAlias, postNotificationTokken, postTerminosCondiciones } from "../../../api/Api";
import PdfViewer from "../../../components/pdfViewer/PdfViewer";
import { handleDispositivo } from "../../../components/hooks/HooksGlobal";

const PaymentPage = () => {
    const [selectOptions, setSelectOptions] = useState(null);
    const [textAlias, setTextAlias] = useState('');
    const [cargando, setCargando] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [openAlert, setOpenAlert] = useState(false);
    const [showPdf, setShowPdf] = useState(false);
    const [policy, setPolicy] = useState(localStorage.getItem('policy') === null ? false : true);
    const [policyData, setPolicyData] = useState(localStorage.getItem('policy') === null ? false : true);

    let history = useNavigate();

    const { state } = useLocation();

    console.log("state===>", state);

    const stateToken = useSelector(state => state.reducerGlobal.token);

    const intervalAliasConsulta = useRef(null);
    const timerRef = useRef(null);
    let intervalApiConsulta = 5000;
    let timerCloseApi = 60000; //1 minuto

    const handleCloseAlert = () => {
        setOpenAlert(false);
    }


    //label e id
    const arrayOptions = [
        { label: 'C.I', code: 'CI', id: 1 },
        { label: 'R.U.C', code: 'RUC', id: 2 },
        { label: 'Telefono/Celular', code: 'MOBILE', id: 3 },
        { label: 'Email', code: 'EMAIL', id: 4 }
    ];

    const handleSelectOptions = (event, newValue) => {
        setSelectOptions(newValue);
        setTextAlias('');
    };


    const handleAlias = (e) => {
        //si tiene espacios en blanco, al inicio o al final, los elimino
        // setTextAlias(e.target.value.trim());
        if (selectOptions?.code === 'MOBILE') {
            //se deja ingresar solo numeros, hasta 9 digitos
            setTextAlias(e.target.value.replace(/\D/g, '').replace(/(\d{9})(\d)/, '$1'));
        } else if (selectOptions?.code === 'EMAIL') {
            setTextAlias(e.target.value);
        } else if (selectOptions?.code === 'CI') {
            //solo se permiten numeros hasta 7 digitos
            setTextAlias(e.target.value.replace(/\D/g, '').replace(/(\d{7})(\d)/, '$1'));
        } else if (selectOptions?.code === 'RUC') {
            //solo se ingresa hasta 10 digitos
            if (e.target.value.length <= 10) {
                setTextAlias(e.target.value.replace(/[^0-9-]/g, '').replace(/(\d{9})(\d)/, '$1'));
            } else {
                setTextAlias(e.target.value.slice(0, 10));
            }
        } else {
            // setTextAlias(e.target.value);
            setOpenAlert(true);
            setSeverity('warning');
            setMensaje('Seleccione una opción');
        }
    };







    const validarBottonPago = () => {
        //valido que el banco seleccionado no este vacio, y el resto no este vacio o con espacios en blanco
        if ((selectOptions !== null && textAlias !== '' && textAlias.trim() !== '') && policy !== false) {
            return false;
        } else {
            return true;
        }
    };

    //id operacion
    const parseIdOperacion = () => {
        let idOperacion = stateToken.codeComercio;
        // Generar la fecha en formato YYMMDD
        const date = new Date();
        const formattedDate = date
            .toISOString()
            .slice(2, 10)
            .replace(/-/g, '');

        // Generar el session id basado en el tiempo transcurrido en el día
        const time = new Date();
        const millis = time.getTime() % 1_000_000;
        // Asegurar que el sessionId tiene longitud 8
        const sessionId = millis.toString().padStart(8, '0');

        return idOperacion + formattedDate + sessionId;
    }

    const handleSolicitarPagos = () => {
        let body = {};

        body.idOperacion = parseIdOperacion();
        body.codComercio = stateToken.codeComercio;
        // body.alias = textAlias;
        body.alias = selectOptions.code === "MOBILE" ? "595" + textAlias : textAlias;
        body.tipoAlias = selectOptions.code;
        body.importe = state.monto.replace(/\./g, '') + '00';
        body.motivo = "transferencia";

        console.log("body===>", body);

        //verifico cuando el alias es un email, si tiene el formato correcto @
        if (selectOptions.code === 'EMAIL') {
            if (textAlias.includes('@')) {
                //si tiene el formato correcto, envio la solicitud de pago
                handleApiTransferir(body);

                if (!policyData) {
                    handleTerminosCondicion();
                }
            } else {
                //si no tiene el formato correcto, muestro un mensaje de error
                setOpenAlert(true);
                setSeverity('warning');
                setMensaje('Ingrese un email válido');
            }
        } else {
            //si no es un email, envio la solicitud de pago
            handleApiTransferir(body);

            if (!policyData) {
                handleTerminosCondicion();
            }
        }
    };

    const handleTerminosCondicion = () => {

        let body = {};
        body.codComercio = stateToken.codeComercio;
        body.usuario = stateToken.userName;

        postTerminosCondiciones(body)
            .then(response => {
                console.log("response===>", response);

            })
            .catch(error => {
                console.log("error===>terminoCondicion", error);


            });

    };

    const handleApiTransferir = (body) => {
        setCargando(true);
        postAliasTransferir(body)
            .then(response => {
                if (response.header.codRespuesta === '0') {
                    handleApiConsultas(body);
                    
                    // if (handleDispositivo() === 'Android' || handleDispositivo() === 'IOS') {
                    //     handleApiConsultasToken(body);
                    // }

                    intervalAliasConsulta.current = setInterval(() => {
                        console.log('entro al intervalo')
                        handleApiConsultas(body);

                        // if (handleDispositivo() === 'Android' || handleDispositivo() === 'IOS') {
                        //     handleApiConsultasToken(body);
                        // }
                    }, intervalApiConsulta);

                    timerRef.current = setTimeout(() => {
                        console.log('termino los 1 minuto')
                        clearInterval(intervalAliasConsulta.current);
                        clearTimeout(timerRef.current);
                        setCargando(false);
                        setOpenAlert(true);
                        setSeverity('warning');
                        setMensaje('El tiempo para pagar ha expirado');
                        history('/home/payment/verificacion', { state: body, replace: true });
                    }, timerCloseApi);

                } else {
                    setCargando(false);
                    setOpenAlert(true);
                    setSeverity('warning');
                    setMensaje(response.header.txtRespuesta);
                }
            })
            .catch(error => {
                console.log("error===>", error);
                setCargando(false);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje('Error al solicitar el pago');

            })
    }

    const handleApiConsultas = (body) => {
        let bodyData = {};
        bodyData.idOperacion = body.idOperacion;
        bodyData.timeout = "0";


        postConsultaPagoAlias(bodyData)
            .then(response => {
                // console.log("response===>", response);
                if (response.header.codRespuesta === '0') {

                    if (response.data.estado === "AP") {
                        setCargando(false);
                        clearInterval(intervalAliasConsulta.current);
                        clearTimeout(timerRef.current);

                        history('/home/payment/confirmacion', { state: response.data, replace: true });
                    } else if (response.data.estado === "RE") {
                        setCargando(false);
                        clearInterval(intervalAliasConsulta.current);
                        clearTimeout(timerRef.current);
                        setOpenAlert(true);
                        setSeverity('warning');
                        setMensaje('El pago fue rechazado');
                    }
                } else {
                    setCargando(false);
                    setOpenAlert(true);
                    setSeverity('warning');
                    setMensaje(response.header.txtRespuesta);
                    // clearInterval(intervalAliasConsulta.current);
                }
            })
            .catch(error => {
                console.log("error===>", error);
                setCargando(false);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje('Error al consultar el pago');

            })
    }

    const handleApiConsultasToken = (body) => {
        let bodyData = {};
        bodyData.idOperacion = body.idOperacion;
        bodyData.timeout = "0";
        
        let dataSotrage = localStorage.getItem('tokenNotificacion');
        let token = JSON.parse(dataSotrage);
        bodyData.token = token?.fcm_token;

        postNotificationTokken(bodyData)
            .then(response => {
                // console.log("response===>", response);
            })
            .catch(error => {
                console.log("error===>", error);
            })
    }

    const handleClickTermyCondi = () => {
        setShowPdf(true);
    }

    const handlePolicy = () => {
        let body = {};
        body.codComercio = stateToken.codeComercio;
        body.userName = stateToken.userName;
        //agregar objeto de la fecha actual en formato YYYY-MM-DD
        // body.fecha = new Date().toISOString().slice(0, 10);


        setPolicy(!policy);
        if (!policy) {
            localStorage.setItem('policy', 'true');
            console.log("body===>politicas", body);
        } else {
            localStorage.removeItem('policy');
        }
    }


    return (
        <HeaderCustom title="Sicoop Comercios">
            {showPdf ? <PdfViewer pdf={'/static/Terminos_y_Condiciones.pdf'}
                onCancel={() => setShowPdf(false)}
                visible={showPdf}
            /> : null}

            {state && (
                <MaxDiv>
                    <PaperStyle>
                        <div>
                            <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                                Complete los datos para realizar el pago
                            </TypographyStyleSecundary>

                            <Box sx={{}} mt={2}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={arrayOptions}
                                    onChange={handleSelectOptions}
                                    renderInput={(params) => <TextField {...params} label="Seleccione una opción" />}
                                />
                            </Box>


                            <Box sx={{}} mt={2}>
                                <CssTextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    fullWidth
                                    placeholder="Ingrese el alias"
                                    label="Alias"
                                    size="medium"
                                    value={textAlias}
                                    onChange={handleAlias}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" sx={{}}>
                                                {/*agregar icono de acuerdo al tipo de alias seleccionado*/}
                                                {selectOptions && selectOptions.code === 'MOBILE' && <TypographyStyleSecundary gutterBottom variant="subtitle1" style={{ color: 'GrayText', marginTop: 5 }}>
                                                    +595
                                                </TypographyStyleSecundary>}

                                                {/* {selectOptions && selectOptions.code === 'CI' && <AccountCircle sx={{ marginTop: -0.2 }} />} */}
                                                {selectOptions && selectOptions.code === 'CI' &&
                                                    <img
                                                        src={dni}
                                                        alt="logosicoop"
                                                        width={35}
                                                        height={35}
                                                    />
                                                }

                                                {selectOptions && selectOptions.code === 'RUC' && <TypographyStyleSecundary gutterBottom variant="subtitle1" style={{ color: 'GrayText', marginTop: 5 }}>
                                                    RUC
                                                </TypographyStyleSecundary>}


                                                {selectOptions && selectOptions.code === 'EMAIL' && <Email sx={{ marginTop: -0.2 }} />}

                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>


                            <Box sx={{}} mt={2}>
                                <TypographyStyleSecundary gutterBottom variant="h5" style={{ color: 'GrayText' }}>
                                    Monto a pagar
                                </TypographyStyleSecundary>

                                <TypographyStyleSecundary gutterBottom variant="h5" >
                                    {/* Gs. {state.monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} */}
                                    Gs. {parseFloat(state.monto).toLocaleString('es-PY')}
                                </TypographyStyleSecundary>
                            </Box>



                            <Box sx={{}} mt={2}>
                                <ButtonStyleVerde
                                    variant="contained"
                                    style={{
                                        width: '100%',
                                        height: '50px',
                                        borderRadius: '10px'
                                    }}
                                    startIcon={<AccountBalance />}
                                    disabled={validarBottonPago()}
                                    onClick={handleSolicitarPagos}
                                >
                                    Solicitar Pago
                                </ButtonStyleVerde>
                            </Box>

                            {!policyData &&
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Checkbox
                                        checked={policy}
                                        name="policy"
                                        // onChange={() => setPolicy(!policy)}
                                        onChange={handlePolicy}
                                    />
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        {'He leido los'}
                                        <Link
                                            target="_blank"
                                            onClick={handleClickTermyCondi}
                                        >
                                            {'Terminos y Condiciones'}
                                        </Link>
                                    </Typography>
                                </Box>
                            }
                        </div>
                    </PaperStyle>
                </MaxDiv>
            )}

            {cargando &&
                <Box sx={{}} mt={2}>
                    <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                        Esperando confirmación del pago...
                    </TypographyStyleSecundary>
                </Box>
            }

            <Snackbar open={openAlert} autoHideDuration={10000} onClose={handleCloseAlert}>
                <Alert
                    onClose={handleCloseAlert}
                    severity={severity}
                    elevation={6}
                // variant="filled"
                >
                    {mensaje}
                </Alert>
            </Snackbar>

            {cargando && <SplashLoading cargando={cargando} />}
        </HeaderCustom>
    )
}

export default PaymentPage;